import { Controller } from "@hotwired/stimulus"
import { baseKit } from "../shared/browserKit"
import MakaseController from "./makase_controller"

export default baseKit(({ turboFrameReload, asArray, queryStringAssign }) => {
  return class TurbineController extends Controller {
    connect() {
      // turbo frame tag가 아니면 콘솔에 경고 메시지 출력
      if (this.element.tagName.toLowerCase() !== "turbo-frame") {
        console.warn("This controller is intended to be used with <turbo-frame> elements.")
      }

      // MakaseController.useEventAction 등록: ->turbine#reload, ->turbine#console
      MakaseController.useEventAction(this, "recall")
      MakaseController.useEventAction(this, "reload")
      MakaseController.useEventAction(this, "console")

      if (this.element.id) {
        MakaseController.useEventAction(this, "recall", { domain: this.element.id })
        MakaseController.useEventAction(this, "reload", { domain: this.element.id })
        MakaseController.useEventAction(this, "console", { domain: this.element.id })
      }

      this.element.addEventListener("turbo:before-frame-render", (event) => {
        event?.stopPropagation?.()
        const targetFrame = event.target
        const element = this.element
        if (targetFrame == element) {
          // 이전 flash 심볼을 제거 
          if (element.hasAttribute("data-turbine-flash-symbol")) {
            element.removeAttribute("data-turbine-flash-symbol")
          }
          // data-turbine-flash-value 값을 data-turbine-flash-symbol로 이동
          const reservedFlashValue = element.getAttribute("data-turbine-flash-value")
          if (reservedFlashValue) {
            element.setAttribute("data-turbine-flash-symbol", reservedFlashValue)
            console.log("set data-turbine-flash-symbol:", reservedFlashValue)
            element.removeAttribute("data-turbine-flash-value")
            console.log("remove data-turbine-flash-value")
          }
        }
      })
    }

    recall(event) {
      // turbineRecallMatcher 가 없으면 매칭은 true
      const turbineRecallMatcher = event?.detail?.turbineRecallMatcher || event?.params?.turbineRecallMatcher
      if (turbineRecallMatcher) {
        const targetMatch = turbineRecallMatcher(this.element)
        if (!targetMatch) return
      }
      // recall 시작
      event?.stopPropagation?.()
      const turbineRecallMain = event?.detail?.turbineRecall || event?.params?.turbineRecall
      if (typeof turbineRecallMain === "function") {
        try {
          turbineRecallMain(this)
        } catch (error) {
          console.error("Error in turbineRecall:", error)
        }
      } else {
        console.warn("turbine#recall requires a turbineRecall function in its detail or params.", turbineRecallMain)
      }
    }

    reload(event) {
      // turbineRecallMatcher 가 없으면 매칭은 true
      const turbineReloadMatcher = event?.detail?.turbineReloadMatcher || event?.params?.turbineReloadMatcher
      if (turbineReloadMatcher) {
        const targetMatch = turbineReloadMatcher(this.element)
        if (!targetMatch) return
      }

      event?.stopPropagation?.()

      // candidate for beforeTurbineReload hook (과연 필요한가?)
      // const beforeTurbineReload = event?.params?.beforeTurbineReload
      // if (typeof beforeTurbineReload === "function") {
      //   try {
      //     beforeTurbineReload()
      //   } catch (error) {
      //     console.error("Error in beforeTurbineReload:", error)
      //   }
      // }

      const flashParams = event?.params?.flash
      Promise.resolve(turboFrameReload(this.element.id)).then(() => {
        if (flashParams === 'fade') {
          this.element.classList.add("dd-flash-fade")
          setTimeout(() => {
            this.element.classList.remove("dd-flash-fade")
          }, 800)
        }
      })
    }

    nextFlashValue(messageSymbol) {
      this.element.setAttribute("data-turbine-flash-value", messageSymbol)
    }

    flashIfMatched(flashSymbol, callback) {
      const currentFlashValue = this.element.getAttribute("data-turbine-flash-symbol")
      const matchedSymbol = asArray(flashSymbol).find((flashName) => { return flashName === currentFlashValue })
      if (matchedSymbol) {
        if (callback && typeof callback === "function") {
          return callback(currentFlashValue)
        } else {
          return currentFlashValue
        }
      }
    }

    get initialSrc() {
      return this.element.getAttribute("data-src")
    }

    get currentSrc() {
      return this.element.getAttribute("src")
    }

    resetSrc(assignParams) {
      const currentSrc = this.currentSrc
      const newSrc = queryStringAssign(this.initialSrc, assignParams)
      this.element.src = newSrc
      return [currentSrc, newSrc, { changed: currentSrc !== newSrc }]
    }

    stop() {
      this.element.setAttribute("disabled", "true")
    }

    resume() {
      this.element.removeAttribute("disabled")
    }

    // debug용 콘솔 메서드
    console(event) {
      // turbineRecallMatcher 가 없으면 매칭은 true
      const turbineConsoleMatcher = event?.detail?.turbineConsoleMatcher || event?.params?.turbineConsoleMatcher
      if (turbineConsoleMatcher) {
        const targetMatch = turbineConsoleMatcher(this.element)
        if (!targetMatch) return
      }

      event?.stopPropagation?.()
      console.log("turbine#console", { controller: this, event })
    }
  }
})
